<template>
  <div class="mmain"  v-title data-title="北京天蔚中医药发展促进中心-合作交流">
    <mClass :nav="nav" ></mClass>
  </div>
</template>
<script>
import mClass from "@/components/mClass.vue";
import Bus from "@/utils/bus.js"
export default {
  data() {
    return {
      nav: [
        { title: "留言板", url: "mLyb" },
        { title: "问题解答", url: "mWtjd" },
        { title: "合作模式", url: "mHzms" },
      ],
    };
  },
  mounted() {
    this.$nextTick(function() {
      Bus.$emit("getpCurrent", "mJlzx");
    });
  },
  methods: {
  },
  components: {
    mClass
  }
};
</script>

<style lang="less" scoped>
.mmain{
   width: 100%;
}
</style>